import gql from 'graphql-tag';

const getCardGroupsQuery = gql`
  query getCardGroups($offset: Int = 0, $limit: Int = 20) {
    cardGroups(slice: { offset: $offset, limit: $limit }) {
      total
      records {
        id
        name
      }
    }
  }
`;

export default getCardGroupsQuery;
